import { BehaviorSubject } from 'rxjs';

import BaseService from './base.service';

export default class PatientService extends BaseService {
  getPatientByEmail(email) {
    return this.get(`/patients/by-email?email=${encodeURIComponent(email)}&workspaceId=${this.getWorkspaceId()}`);
  }

  getPatients(criteria) {
    const queryString = this.getQueryString(criteria);
    return this.get(`/patients${queryString}`);
  }

  reinvitePatient(patient) {
    return this.put(`/patients/resend-invitation/${patient.userId}`, patient);
  }

  getPatientRecords(criteria) {
    const queryString = this.getQueryString(criteria);
    return this.get(`/patients/record${queryString}`);
  }

  getRecord(id) {
    return this.get(`/patients/record/${id}`);
  }

  addStudy(payload, progress$ = new BehaviorSubject(0)) {
    const formData = new FormData();
    payload.files.forEach((file) => {
      formData.append(`files`, file);
    });
    if (payload.title) {
      formData.append('title', payload.title);
    }
    if (payload.fileType) {
      formData.append('fileType', payload.fileType);
    }

    return this.sendFormData('POST', '/patients/study', formData, progress$);
  }

  downloadFiles(recordId) {
    return this.get(`/patients/record/${recordId}/download`);
  }

  downloadDowngradeFiles(recordIds) {
    return this.post(`/patients/record/download/batch`, { recordIds });
  }

  removeFiles(recordId) {
    return this.delete(`/patients/record/${recordId}`);
  }

  getPatientStudies() {
    return this.get('/patients/study/all');
  }

  getDowngradeRecords() {
    return this.get('/patients/record/can-delete');
  }

  deleteRecords(recordIds) {
    return this.delete('/patients/record', {
      recordIds,
    });
  }

  getViewerLink(recordId) {
    return this.get(`/patients/record/${recordId}/viewer-link`);
  }

  getChildResourcesLink(recordId, token = '') {
    return this.get(`/patients/record/${recordId}/child-resources-link`, token);
  }

  getDownloadCompressedStudyLink(resourceId, token) {
    return this.get(`/patients/record/${resourceId}/download-compress-study`, token);
  }

  shareReportEmail(email, name, recordId) {
    return this.post(`/patients/record/${recordId}/share-report-email`, {
      email,
      name,
    });
  }

  viewReportFirstTime(recordId) {
    return this.put(`/patients/record/${recordId}/view-report-first-time`);
  }

  getVideoReportLink(recordId) {
    return this.get(`/patients/record/${recordId}/video-report-link`);
  }
}
